export const MAX_WRAPPER_WIDTH = 1920;
export const VERTICAL_CONTAINER_WIDTH_PERCTENTAGE = 65;
export const VERTICAL_CONTAINER_WIDTH_PERCTENTAGE_SMALL = 95;
export const MAX_IMAGE_HEIGHT = 540;
export const BACKDROP_OPACITY = 0.98;
